module.exports = __webpack_public_path__ + "img/bul_device_union_on.bdb73e74.svg";